import React from "react";
import CrudPage from "@/components/common/CrudPage";
import { Scale } from "lucide-react";
import { useApp } from "@/contexts/AppContext";
import { useAIOutputs } from "@/hooks/useAIOutputs";
import AICategoryPanel from "@/components/ai/AICategoryPanel";

function EvidenceAIPanel() {
  const { currentCase } = useApp();
  const { outputs, addOutput } = useAIOutputs(currentCase?.id);
  return (
    <AICategoryPanel
      caseId={currentCase?.id} promptKey="prosecution_weaknesses" titleEl="Αδυναμίες Κατηγορούσας Αρχής (AI)"
      outputs={outputs} onGenerated={addOutput}
    />
  );
}

const ADMISSIBILITY = [
  { value: "valid", label: "Έγκυρο" },
  { value: "contested", label: "Αμφισβητούμενο" },
  { value: "inadmissible", label: "Απαράδεκτο" },
];
const SIDES = [
  { value: "defense", label: "Υπεράσπιση" },
  { value: "prosecution", label: "Κατηγορία" },
  { value: "neutral", label: "Ουδέτερο" },
];

const FIELDS = [
  { k: "evidence_id", label: "Κωδικός Αποδ. (EV-XXX)" },
  { k: "title", label: "Τίτλος" },
  { k: "type", label: "Τύπος", ph: "Ψηφιακό / Έγγραφο / Φυσικό / κ.λπ." },
  { k: "description", label: "Περιγραφή", type: "textarea", rows: 3 },
  { k: "source", label: "Πηγή" },
  { k: "date", label: "Ημερομηνία", type: "date" },
  { k: "relevance", label: "Συνάφεια", type: "textarea", rows: 2 },
  { k: "admissibility", label: "Παραδεκτό", type: "select", options: ADMISSIBILITY },
  { k: "side", label: "Επιδρά υπέρ", type: "select", options: SIDES },
  { k: "chain_of_custody", label: "Αλυσίδα φύλαξης", type: "textarea", rows: 2 },
  { k: "impact_score", label: "Δείκτης επίδρασης (0-100)", type: "number" },
  { k: "notes", label: "Σημειώσεις", type: "textarea", rows: 2 },
];

export default function Evidence() {
  return (
    <CrudPage
      slug="evidence"
      title="Αποδεικτικά Στοιχεία"
      subtitle="Βάση δεδομένων αποδεικτικών με παραδεκτό, αλυσίδα φύλαξης και επίδραση."
      emptyIcon={Scale}
      fields={FIELDS}
      defaultItem={{ admissibility: "valid", side: "neutral", impact_score: 50 }}
      listColumns={{
        title: it => `${it.evidence_id || "—"} · ${it.title}`,
        subtitle: it => it.type,
        body: it => it.description,
      }}
      badges={{
        admissibility: { field: "admissibility" },
        side: { field: "side" },
      }}
      extra={<EvidenceAIPanel/>}
    />
  );
}
